'use client'

import Stack from '@mui/material/Stack';
import Script from 'next/script';
import dynamic from 'next/dynamic';
const SocialMediaCard = dynamic(() => import('./social-media-card'), { ssr: false });
const FooterLinks = dynamic(() => import('./footer-links'), { ssr: false });

export default function Footer() {

    return <footer
        aria-label="footer"
        className="lg:h-[90px] h-fit w-full"
    >

      {/* <a id="custom-chat-bubble" href="https://t.me/canapply_cs_bot" target="_blank" title="Open chat window">
        <svg width="24" height="24" viewBox="0 0 240 240" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M240.808 240.808H122.123C56.6994 240.808 3.45695 187.562 3.45695 122.122C3.45695 56.7031 56.6994 3.45697 122.124 3.45697C187.566 3.45697 240.808 56.7031 240.808 122.122V240.808Z"
            fill="#FFFFFF"></path>
        </svg>
      </a> */}
      <Stack
            flexWrap={'wrap'}
            direction={'row'}
            spacing={3}
            useFlexGap
            className='items-center lg:px-20 px-2 justify-between h-full pb-8 lg:pb-0'
        >
            <h5>© 2025 CanApply Inc.</h5>
            <SocialMediaCard />
            <FooterLinks />
      </Stack>
      <Script
        src="https://embed.tawk.to/6936ed3e70de34197eda4262/1jbv8tfkf"
        strategy="lazyOnload"
      />
    </footer>
}
